// src/guards/PublicOnly.tsx
import React from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../_services/firebase'

export function PublicOnly({ children }: { children: React.ReactNode }) {
  const { currentUser } = React.useContext(AuthContext)
  if (currentUser !== null) return <Navigate to='/home' replace />
  return <>{children}</>
}
